const ItemMobile = require('../ui-item/mobile');
const withItemBehavior = require('./with-item-behavior');

module.exports = withItemBehavior(ItemMobile);
